import * as React from 'react'
import Spinner from '../components/Spinner'
import moment from 'moment/min/moment-with-locales'

class AddFishScreen extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      fishType: (props.fish.fishTypes && props.fish.fishTypes.length) ? props.fish.fishTypes[0].id : null,
      amount: null,
      expirationTime: moment().add(3, 'days').format("YYYY-MM-DDTHH:mm"),
      restaurantId: 0,
      price: null
    }
  }

  componentDidMount() {
    if( !this.props.users.userListWithType.restaurant )
      this.props.getUserListWithType('restaurant')
  }

  componentWillReceiveProps(nextProps) {
    if( nextProps.app.loading !== this.props.app.loading ) {
      this.setState({
        fishType: (this.props.fish.fishTypes && this.props.fish.fishTypes.length) ? this.props.fish.fishTypes[0].id : null,
        amount: null,
        expirationTime: moment().add(3, 'days').format("YYYY-MM-DDTHH:mm"),
        restaurantId: 0,
        price: null
      })
      setTimeout( () => { this.props.appMessage('') }, 6000)
    }
  }

  addReservation = () => {
    const { fishType, amount, restaurantId } = this.state,
          expirationTime = moment(this.state.expirationTime).toDate(),
          orderTime = new Date()
          
    let reservationObj = {  fishType, 
                            amount: parseInt(amount, 10), 
                            restaurantId, 
                            expirationTime, 
                            orderTime, 
                            active: true,
                            price: parseInt(this.state.price, 10)
                          }
    this.props.addFishReservation(reservationObj)
  }

  addBtnDisabled() {
    const { fishType, amount, expirationTime, restaurantId, price } = this.state
    if( fishType && amount && expirationTime && restaurantId!=='0' && restaurantId && price ) return false
    return true
  }

  render() {
    const { fishTypes } = this.props.fish
    if( this.props.app.loading ) return <Spinner />
    if( !this.props.users.userListWithType.restaurant ) return <Spinner />
    if( !this.props.users.userListWithType.restaurant.length ) return <div className="alert alert-danger">Uwaga: brak restauracji. Najpierw dodaj restaurację!</div>

    return (
      <div>
        { this.props.app.message.length>0 && <div className="alert alert-danger">{this.props.app.message}</div>}
        <form>
          
          <div className="form-group">
            <label>Wybierz restaurację</label>
            <select className="form-control" onChange={event => this.setState({ restaurantId: event.target.value })}>
              <option key='noselect' value={0}>Wybierz restaurację</option>
              {this.props.users.userListWithType.restaurant.map( (f, key) => <option key={key} value={f.id}>{f.name} {f.email}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label>Wybierz gatunek</label>
            <select className="form-control" onChange={event => this.setState({ fishType: event.target.value })}>
              {fishTypes.map( (f, key) => <option key={key} value={f.id}>{f.name}</option>)}
            </select>
          </div>

          { this.state.fishType!==null &&
            <React.Fragment>
              <div className="form-group">
                <label>Ilość</label>
                <div className="input-group">
                  <input
                    type="number"
                    className="form-control" 
                    placeholder="Ilość" 
                    onChange={event=>this.setState({ amount: event.target.value })}
                    defaultValue={this.state.amount}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">{fishTypes.filter(f=>f.id===this.state.fishType)[0].amount.kg ? 'kg' : 'sztuk'}</span>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Max. oferowana cena za {fishTypes.filter(f=>f.id===this.state.fishType)[0].amount.kg ? 'kilogram' : 'sztukę'}</label>
                <div className="input-group">
                  <input 
                    type="number"
                    className="form-control" 
                    placeholder="Podaj cenę (tylko cyfry)"
                    onChange={event=>this.setState({ price: event.target.value })}
                    defaultValue={this.state.price}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">PLN</span>
                  </div>
                </div>
              </div>
            
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Data ważności zamówienia</label>
                <p className="m-0 small text-muted">Zamówienie jest aktywne max. 3 dni.{"\n"}Jeśli w tym okresie nie pojawi się zamówiona ryba, zamowienie automatycznie wygaśnie.</p>
                <input 
                  type="datetime-local" 
                  className="form-control"
                  onChange={event=>this.setState({ expirationTime: event.target.value })}
                  defaultValue={this.state.expirationTime}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary mt-2"
                disabled={ this.addBtnDisabled() }
                onClick={ this.addReservation }
              >Dodaj
              </button>
            </React.Fragment>
          }

        </form>
      </div>
    )
  }
}


export default AddFishScreen



// WEBPACK FOOTER //
// ./src/screens/AddReservationScreen.js